import { BankAccountIcon, BoxIcon, CalendarIcon, ChartIcon, ClipboardIcon, CreditCardIcon, DashboardIcon, DatabaseIcon, DataLineageIcon, DiagramTreeIcon, ExchangeIcon, LayoutLinearIcon, ListIcon, Menu, Pane, ShopIcon, ShoppingCartIcon, SquareIcon, StarIcon, TimeIcon, TruckIcon, UserIcon } from 'evergreen-ui';
import { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { MOBILE_BREAKPOINT } from '../Layouts/layoutConstants';
import './OrchestraMenu.css';

// Role level constants
const ROLE_LEVEL_ADMIN = 3;

class OrchestraMenu extends Component {
    constructor(props) {
        super(props);
        this.menuRef = null;
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    isAdmin = () => {
        const { user } = this.props;
        return user && user.role && user.role.level >= ROLE_LEVEL_ADMIN;
    }

    handleClickOutside(event) {
        // Only handle click outside on mobile (< MOBILE_BREAKPOINT) when sidebar is open
        if (window.innerWidth < MOBILE_BREAKPOINT && this.props.isOpen) {
            if (this.menuRef && !this.menuRef.contains(event.target)) {
                this.props.onClose();
            }
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    render() {
        const { isOpen } = this.props;
        const isAdmin = this.isAdmin();

        return (
            <>
                {/* Overlay for mobile when sidebar is open */}
                <div className={`sidebar-overlay ${isOpen ? 'visible' : ''}`} onClick={this.props.onClose} />

                <Pane
                    ref={ref => this.menuRef = ref}
                    className={`orchestra-menu ${isOpen ? 'open' : 'closed'}`}
                    width={200}
                    maxHeight="calc(100vh - 60px)"
                    minWidth={200}
                    overflowY="auto"
                >
                    <Menu>
                        <Menu.Group title="Principal">
                            <Link to="/dashboard">
                                <Menu.Item
                                    backgroundColor={this.props.route.indexOf('/dashboard') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}
                                    icon={DashboardIcon}>Dashboard</Menu.Item>
                            </Link>

                            <Link to="/orders">
                                <Menu.Item icon={ShopIcon}
                                    backgroundColor={this.props.route.indexOf('/orders') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                        Comenzi
                                </Menu.Item>
                            </Link>
                            {isAdmin && (
                                <Link to="/carts">
                                    <Menu.Item icon={ShoppingCartIcon}
                                        backgroundColor={this.props.route.indexOf('/carts') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                            Cosuri
                                    </Menu.Item>
                                </Link>
                            )}
                        </Menu.Group>
                        <Menu.Divider/>
                        <Menu.Group title="Date">
                            <Link to="/products">
                                <Menu.Item icon={BoxIcon}
                                    backgroundColor={this.props.route.indexOf('/products') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                        Produse
                                </Menu.Item>
                            </Link>
                            {isAdmin && (
                                <Link to="/catalog">
                                    <Menu.Item icon={DatabaseIcon}
                                        backgroundColor={this.props.route.indexOf('/catalog') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                            Catalog
                                    </Menu.Item>
                                </Link>
                            )}
                            <Link to="/cards">
                                <Menu.Item icon={SquareIcon}
                                    backgroundColor={this.props.route.indexOf('/cards') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                        TCG Singles
                                </Menu.Item>
                            </Link>
                            {isAdmin && (
                                <>
                                    <Link to="/product-lists">
                                        <Menu.Item icon={BoxIcon}
                                            backgroundColor={this.props.route.indexOf('/product-lists') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Liste Produse
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/category-lists">
                                        <Menu.Item icon={BoxIcon}
                                            backgroundColor={this.props.route.indexOf('/category-lists') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Liste Categorii
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/users">
                                        <Menu.Item icon={UserIcon}
                                            backgroundColor={this.props.route.indexOf('/users') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Utilizatori
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/offers">
                                        <Menu.Item icon={BankAccountIcon}
                                            backgroundColor={this.props.route.indexOf('/offers') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Oferte
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/vouchers">
                                        <Menu.Item icon={BankAccountIcon}
                                            backgroundColor={this.props.route.indexOf('/vouchers') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Vouchere
                                        </Menu.Item>
                                    </Link>
                                </>
                            )}
                        </Menu.Group>
                        {isAdmin && (
                            <>
                                <Menu.Divider/>
                                <Menu.Group title="Reports">
                                    <Link to="/reports/legacy-reports">
                                        <Menu.Item icon={ChartIcon}
                                            backgroundColor={this.props.route.indexOf('/reports/legacy-reports') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Legacy Reports
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/reports/new-reports">
                                        <Menu.Item icon={ChartIcon}
                                            backgroundColor={this.props.route.indexOf('/reports/new-reports') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                New Reports
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/reports/gamesworkshop-stockcheck">
                                        <Menu.Item icon={ChartIcon}
                                            backgroundColor={this.props.route.indexOf('/reports/gamesworkshop-stockcheck') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                GamesWorkshop Stockcheck
                                        </Menu.Item>
                                    </Link>
                                </Menu.Group>
                            </>
                        )}
                        <Menu.Divider/>
                        <Menu.Group title="CMS">
                            <Link to="/calendar">
                                <Menu.Item icon={CalendarIcon}
                                    backgroundColor={this.props.route.indexOf('/calendar') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                        Calendar
                                </Menu.Item>
                            </Link>
                            {isAdmin && (
                                <>
                                    <Link to="/carousel">
                                        <Menu.Item icon={LayoutLinearIcon}
                                            backgroundColor={this.props.route.indexOf('/carousel') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Carusel
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/interest-registrations">
                                        <Menu.Item icon={StarIcon}
                                            backgroundColor={this.props.route.indexOf('/interest-registrations') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Înregistrări Interes
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/sidebar">
                                        <Menu.Item icon={ListIcon}
                                            backgroundColor={this.props.route.indexOf('/sidebar') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Sidebar Meniu
                                        </Menu.Item>
                                    </Link>
                                </>
                            )}
                        </Menu.Group>
                        {isAdmin && (
                            <>
                                <Menu.Divider/>
                                <Menu.Group title="Administrare">
                                    <Link to="/attributes">
                                        <Menu.Item icon={DataLineageIcon}
                                            backgroundColor={this.props.route.indexOf('/attributes') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Atribute
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/categories">
                                        <Menu.Item icon={DiagramTreeIcon}
                                            backgroundColor={this.props.route.indexOf('/categories') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Categorii
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/suppliers">
                                        <Menu.Item icon={BoxIcon}
                                            backgroundColor={this.props.route.indexOf('/suppliers') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Furnizori
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/stock-operations">
                                        <Menu.Item icon={TruckIcon}
                                            backgroundColor={this.props.route.indexOf('/stock-operations') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Operatii Stocuri
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/inventory-buffer">
                                        <Menu.Item icon={BoxIcon}
                                            backgroundColor={this.props.route.indexOf('/inventory-buffer') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Inventory Buffer
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/payment-types">
                                        <Menu.Item icon={CreditCardIcon}
                                            backgroundColor={this.props.route.indexOf('/payment-types') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Modalitati Plata
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/stock-accounts">
                                        <Menu.Item icon={ClipboardIcon}
                                            backgroundColor={this.props.route.indexOf('/stock-accounts') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Conturi
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/short-urls">
                                        <Menu.Item icon={BoxIcon}
                                            backgroundColor={this.props.route.indexOf('/short-urls') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Short URL-uri
                                        </Menu.Item>
                                    </Link>
                                    <Link to="/shipment-manifests">
                                        <Menu.Item icon={TruckIcon}
                                            backgroundColor={this.props.route.indexOf('/shipment-manifests') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                                Borderouri Livrari
                                        </Menu.Item>
                                    </Link>
                                </Menu.Group>
                            </>
                        )}
                        <Menu.Divider/>
                        <Menu.Group title="Gestiune Magazine">
                            <Link to="/schedule-program">
                                <Menu.Item icon={TimeIcon}
                                    backgroundColor={this.props.route.indexOf('/schedule-program') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                        Program Angajați
                                </Menu.Item>
                            </Link>
                            <Link to="/schedule-change-requests">
                                <Menu.Item icon={ExchangeIcon}
                                    backgroundColor={this.props.route.indexOf('/schedule-change-requests') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                        Cereri Modificare
                                </Menu.Item>
                            </Link>
                            <Link to="/vacation-requests">
                                <Menu.Item icon={CalendarIcon}
                                    backgroundColor={this.props.route.indexOf('/vacation-requests') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                        Cereri Concediu
                                </Menu.Item>
                            </Link>
                            {isAdmin && (
                                <Link to="/shops">
                                    <Menu.Item icon={ShopIcon}
                                        backgroundColor={this.props.route.indexOf('/shops') === 0 ? 'rgba(67, 90, 111, 0.1)' : 'none'}>
                                            Magazine
                                    </Menu.Item>
                                </Link>
                            )}
                        </Menu.Group>
                    </Menu>
                </Pane>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        route: state.router.location.pathname,
        user: state.authentication.user
    }
}

export default connect(mapStateToProps)(OrchestraMenu);
